"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getLinkProps = void 0;

var _react = _interopRequireDefault(require("react"));

var _router = require("@reach/router");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledMediaQuery = _interopRequireDefault(require("styled-media-query"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Utils = _interopRequireWildcard(require("../../Utils"));

var _SocialIcons = _interopRequireDefault(require("../SocialIcons"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    justify-content: center;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    text-align: center;\n    width: 100%;\n\n    img { \n      display: block;\n      margin: 0 auto;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ColHeader = _styledComponents["default"].div.withConfig({
  displayName: "Grocery__ColHeader",
  componentId: "sc-1or67dn-0"
})(["padding:1rem;", ""], _styledMediaQuery["default"].lessThan('medium')(_templateObject()));

var Col = _styledComponents["default"].div.withConfig({
  displayName: "Grocery__Col",
  componentId: "sc-1or67dn-1"
})(["padding:1rem;"]);

var ColList = _styledComponents["default"].ul.withConfig({
  displayName: "Grocery__ColList",
  componentId: "sc-1or67dn-2"
})(["list-style:none;margin:0;padding:0;"]);

var ColListTitle = _styledComponents["default"].h4.withConfig({
  displayName: "Grocery__ColListTitle",
  componentId: "sc-1or67dn-3"
})(["font-weight:bold;font-size:1rem;margin:0 0 1rem;"]);

var ColListItem = _styledComponents["default"].li.withConfig({
  displayName: "Grocery__ColListItem",
  componentId: "sc-1or67dn-4"
})(["margin-bottom:0.5rem;"]);

var ColListItemLink = (0, _styledComponents["default"])(_router.Link).withConfig({
  displayName: "Grocery__ColListItemLink",
  componentId: "sc-1or67dn-5"
})(["color:#fff;text-decoration:none;transition:color 500ms;&:hover{opacity:1;text-decoration:underline;}"]);

var Footer = _styledComponents["default"].footer.withConfig({
  displayName: "Grocery__Footer",
  componentId: "sc-1or67dn-6"
})(["background:", ";color:#fff;padding:1rem;"], function (_ref) {
  var _ref$theme$dark = _ref.theme.dark,
      dark = _ref$theme$dark === void 0 ? '#222' : _ref$theme$dark;
  return dark;
});

var Grid = _styledComponents["default"].div.withConfig({
  displayName: "Grocery__Grid",
  componentId: "sc-1or67dn-7"
})(["display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-around;", ""], _styledMediaQuery["default"].lessThan('small')(_templateObject2()));

var getLinkProps = function getLinkProps(_ref2) {
  var isCurrent = _ref2.isCurrent;
  return {
    style: {
      opacity: isCurrent ? '1' : '.65'
    }
  };
};

exports.getLinkProps = getLinkProps;

var Grocery = function Grocery(_ref3) {
  var children = _ref3.children,
      columns = _ref3.columns,
      social = _ref3.social;
  return /*#__PURE__*/_react["default"].createElement(Footer, null, /*#__PURE__*/_react["default"].createElement(Utils.Container, {
    size: "large"
  }, /*#__PURE__*/_react["default"].createElement(Grid, null, /*#__PURE__*/_react["default"].createElement(ColHeader, null, children, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("small", null, "\xA9 ", new Date().getFullYear(), ". All rights reserved")), columns.map(function (co) {
    return /*#__PURE__*/_react["default"].createElement(Col, null, /*#__PURE__*/_react["default"].createElement(ColListTitle, null, co.label), /*#__PURE__*/_react["default"].createElement(ColList, null, co.items.map(function (_ref4) {
      var label = _ref4.label,
          _ref4$href = _ref4.href,
          href = _ref4$href === void 0 ? '/' : _ref4$href;
      return /*#__PURE__*/_react["default"].createElement(ColListItem, {
        key: label
      }, /*#__PURE__*/_react["default"].createElement(ColListItemLink, {
        to: href,
        getProps: getLinkProps
      }, label));
    })));
  }), /*#__PURE__*/_react["default"].createElement(ColHeader, null, /*#__PURE__*/_react["default"].createElement(_SocialIcons["default"], {
    socials: social
  })))));
};

Grocery.propTypes = {
  social: _propTypes["default"].arrayOf(_propTypes["default"].string),
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    href: _propTypes["default"].string
  })),
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string, _propTypes["default"].array])
};
Grocery.defaultProps = {
  social: [],
  columns: [],
  children: null
};
var _default = Grocery;
exports["default"] = _default;